import { render, staticRenderFns } from "./TableBuscadorIncidencias.vue?vue&type=template&id=7870890c"
import script from "./TableBuscadorIncidencias.vue?vue&type=script&lang=js"
export * from "./TableBuscadorIncidencias.vue?vue&type=script&lang=js"
import style0 from "./TableBuscadorIncidencias.vue?vue&type=style&index=0&id=7870890c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports